// src/utils/time.js
/**
 * Split a 12-hour time string into "h:mm" and "AM/PM".
 * Examples accepted: "7 pm", "7:5 pm", "07:05PM", "12:00 am"
 * Returns { main: "h:mm", mer: "AM"|"PM" } or null if not a 12h time.
 */
export function splitMeridiem(input) {
  const s = String(input ?? "").trim();
  const m = s.match(/^(\d{1,2})(?::(\d{1,2}))?\s*([AaPp]\.?[Mm]\.?)$/);
  if (!m) return null;

  const hh = m[1];
  const mm = (m[2] ?? "00").padStart(2, "0");
  const mer = m[3].replace(/\./g, "").toUpperCase(); // AM | PM

  const hNum = Number(hh);
  const mNum = Number(mm);
  if (hNum < 1 || hNum > 12 || mNum < 0 || mNum > 59) return null;

  // Display hour without leading zero (e.g., "06:24" -> "6:24")
  const main = `${String(hNum)}:${mm}`;
  return { main, mer };
}
